import styles from "./Footer.module.css";
import logo from "../../assets/senca/logo.jpg";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <img src={logo} alt="Logo" className={styles.logo} />
        <p>© 2025 OS Manager - Todos os direitos reservados.</p>
      </div>
      <div className={styles.right}>
        <p>Receba atualizações por e-mail</p>
        <button className={styles.subscribe}>Subscribe</button>
      </div>
    </footer>
  );
}

export default Footer;
